<template>
    <div class="doc-session-row">
        <span v-if="item.cditem" class="doc-session-code">
            {{ item.cditem }}
        </span>

        <span class="doc-session-title">
            {{ item.nmcaption }}
        </span>
    </div>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
});
</script>